import { useContext, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
  Banner,
  BannerList,
  Button,
  PopupDialog,
} from "../../components/design-system/index.js";
import { LoggedInUserContext } from "../../Contexts.js";

export function TrainingWelcomeDialogGeneric() {
  const userContext = useContext(LoggedInUserContext);
  const { t } = useTranslation();

  const [showTrainingBanner, setShowTrainingBanner] = useState(
    userContext?.user?.sessionContext?.isTrainingOrganisation ?? false,
  );

  return (
    <PopupDialog
      open={showTrainingBanner}
      onClose={() => {
        setShowTrainingBanner(false);
      }}
    >
      {" "}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "1em",
        }}
      >
        <IconButton
          aria-label={"Close"}
          onClick={() => {
            setShowTrainingBanner(false);
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            marginLeft: "2em",
            marginRight: "2em",
          }}
        >
          <Banner
            bannerType={BannerList.WARNING}
            title={t("training.dialog")}
          />
        </Box>
        <Box
          sx={{
            paddingLeft: "2em",
            paddingRight: "2em",
            marginTop: "2em",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Button
            label={t("buttonLabels.continue")}
            onClick={() => {
              setShowTrainingBanner(false);
            }}
            color={"primary"}
          />
        </Box>
      </Box>
    </PopupDialog>
  );
}
